import React, { useEffect, useState } from "react";
import "./UserManagement.css";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", is_admin: false });
  const [editingUser, setEditingUser] = useState(null);

  const token = localStorage.getItem("token");

  const fetchUsers = async () => {
    const res = await fetch("https://api.goharesadaf.ir/api/users", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    setUsers(data);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = editingUser ? "PUT" : "POST";
    const url = editingUser
      ? `https://api.goharesadaf.ir/api/users/${editingUser.id}`
      : "https://api.goharesadaf.ir/api/users";

    await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    });

    setForm({ name: "", email: "", password: "", is_admin: false });
    setEditingUser(null);
    fetchUsers();
  };

  const handleDelete = async (id) => {
    await fetch(`https://api.goharesadaf.ir/api/users/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchUsers();
  };

  return (
    <div className="users-container">
      <h2>مدیریت کاربران</h2>

      <form onSubmit={handleSubmit} className="user-form">
        <input
          type="text"
          placeholder="نام"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
        />
        <input
          type="email"
          placeholder="ایمیل"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
        />
        {!editingUser && (
          <input
            type="password"
            placeholder="رمز عبور"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
        )}
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={form.is_admin}
            onChange={(e) => setForm({ ...form, is_admin: e.target.checked })}
          />
          ادمین
        </label>
        <button type="submit">{editingUser ? "به روزرسانی کاربر" : "افزودن کاربر"}</button>
      </form>

      <table className="users-table">
        <thead>
          <tr>
            <th>#</th><th>نام و نام خانوادگی</th><th>ایمیل</th><th>شمارۀ تلفن</th><th>ادمین</th><th>ویرایش/حذف</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u, i) => (
            <tr key={u.id}>
              <td>{i + 1}</td>
              <td>{u.name || "--"}</td>
              <td>{u.email || "--"}</td>
              <td>{u.phone || "--"}</td>
              <td>{u.is_admin ? "✅" : "❌"}</td>
              <td>
                <button onClick={() => { setEditingUser(u); setForm(u); }}>✏️</button>
                <button onClick={() => handleDelete(u.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
